module.exports = __webpack_public_path__ + "static/stamped-7637dae71938cfb9a947f051637ea278.jpeg";